<template>
  <div>
    <v-row>
      <v-col>
        <AnexoManuais />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AnexoManuais from './Shared/AnexoManuais'

export default {
  components: {
    AnexoManuais
  }
}
</script>

<style>
</style>